import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { MentionStatus } from '@/services/types/coverage-types';

interface StatusSummaryCardProps {
  statusCounts: Record<string, number>;
  totalMentions: number;
}

const statusConfig = {
  [MentionStatus.PENDING]: {
    label: 'Pending',
    color: 'bg-yellow-100 text-yellow-800',
  },
  [MentionStatus.PROCESSING]: {
    label: 'Processing',
    color: 'bg-blue-100 text-blue-800',
  },
  [MentionStatus.READY]: {
    label: 'Ready',
    color: 'bg-green-100 text-green-800',
  },
  [MentionStatus.ACCEPTED]: {
    label: 'Accepted',
    color: 'bg-emerald-100 text-emerald-800',
  },
  [MentionStatus.REJECTED]: {
    label: 'Rejected',
    color: 'bg-red-100 text-red-800',
  },
  [MentionStatus.ERROR]: { label: 'Error', color: 'bg-red-100 text-red-800' },
  UNKNOWN: { label: 'Unknown', color: 'bg-gray-100 text-gray-800' },
};

export const StatusSummaryCard = ({
  statusCounts,
  totalMentions,
}: StatusSummaryCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Processing Status</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {Object.entries(statusCounts).map(([status, count]) => {
            const percentage = (count / totalMentions) * 100;
            const config =
              statusConfig[status as keyof typeof statusConfig] ||
              statusConfig.UNKNOWN;

            return (
              <div key={status} className="space-y-2">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Badge variant="secondary" className={config.color}>
                      {config.label}
                    </Badge>
                    <span className="text-sm text-gray-600">
                      {count} mentions
                    </span>
                  </div>
                  <span className="text-sm font-medium">
                    {percentage.toFixed(1)}%
                  </span>
                </div>
                <Progress value={percentage} className="h-2" />
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
